module.exports = __webpack_public_path__ + "static/media/lvjian-bu.42ee659f.png";